import { render } from "./ReviewCalculationDialog.vue?vue&type=template&id=0e7774fa"
import script from "./ReviewCalculationDialog.vue?vue&type=script&lang=ts"
export * from "./ReviewCalculationDialog.vue?vue&type=script&lang=ts"

import "./ReviewCalculationDialog.vue?vue&type=style&index=0&id=0e7774fa&lang=scss"
script.render = render

export default script